import { useContext } from "react";
import { EditorContext } from "../containers/editor/EditorLayout";
import UseCheckWidgetAllignment from "./UseCheckWidgetAllignment";
import useDeleteWidget from "./useDeleteWidget";
import useCheckWidgetPosition from "./useCheckWidgetPosition";

const useCalloutResize = () => {
  let { widgets, updateWidgets } = useContext(EditorContext);

  const { checkWidgetAllignmentForSingleWidget } = UseCheckWidgetAllignment();
  const deleteWidgetIfOutside = useCheckWidgetPosition();
  const setDeleteWidget = useDeleteWidget();

  // ✅ RESIZE START
  const calloutResizeStart = data => {
    const widget = document.querySelector(`#${data.client.id}`);
    const inner = widget.querySelector(".callout");

    // 🔥 Store ORIGINAL width only once (never update again)
    if (!inner.dataset.baseWidth) {
      inner.dataset.baseWidth = inner.offsetWidth;
    }
  };

  // ✅ RESIZING
  const calloutResize = (meta, widgetWidth) => {
    const widget = document.querySelector(`#${meta.client.id}`);
    const inner = widget.querySelector(".callout");
    const wrapper = inner.firstElementChild;

    const baseWidth = parseFloat(inner.dataset.baseWidth);
    if (!baseWidth) return;

    const scale = widgetWidth / baseWidth;

    inner.style.transform = `scale(${scale})`;
    inner.style.transformOrigin = "left top"; // keep original
  };

  // ✅ RESIZE STOP
  const calloutReiszeStop = meta => {
    let updatedCss = meta.client.current;

    let { x_al, y_al } = checkWidgetAllignmentForSingleWidget(
      updatedCss.height,
      updatedCss.transform,
      updatedCss.width
    );

    let isDletable = deleteWidgetIfOutside(meta.client.id);

    if (isDletable) {
      setDeleteWidget(true);
    } else {
      updateWidgets(
        widgets.map((widget, idx) => {
          if (idx === meta.client.idx) {
            return {
              ...widget,
              style: {
                ...widget.style,
                ...updatedCss,
              },
              data: {
                ...widget.data,
                "data-x-allignment": x_al,
                "data-y-allignment": y_al,
              },
              innerHTML: document.getElementById(meta.client.id).innerHTML,
            };
          } else {
            return widget;
          }
        })
      );
    }
  };

  return [calloutResizeStart, calloutResize, calloutReiszeStop];
};

export default useCalloutResize;
